// 聊天 数据
const getDefaultState = () => {
  return {
    chatInfo: null
  };
};
const state = {
  chatInfo: null
};
const mutations = {
  // 添加消息
  ADD_CHAT: (state, chat) => {
    console.log(chat);
    state.chatInfo = chat;
  },
  // 恢复消息
  RESTORE_CHAT: (state, chat) => {
    Object.assign(state, getDefaultState());
  }
};

const actions = {
  addChat({ commit }, chat) {
    commit("ADD_CHAT", chat);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/chat.js